const contact = {
  email: 'annas.alghoffar@gmail.com',
  socials: {
    linkedin: 'https://www.linkedin.com/in/annas-alghoffar/',
    github: 'https://github.com/gogones',
  },
};

export default contact;
